import React from 'react';
import classNames from 'classnames';
import truncate from 'truncate-markup-string';
import {
  Container,
  Image,
  useWindowDimensions,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { DynamicMediaItem } from '@uncinc/react-drupal-core';

import { ParagraphsRenderer } from '../../../components';

import { SCREEN_TABLET } from '../../../config/constants';

import './style.scss';

const NodeLandingPage = ({ entity, className }) => {
  const classes = classNames(className, 'NodeLandingPage');
  const node = entity.toJS();
  const heroTitle = node.title[0].value;
  const heroBody = node.body[0]?.processed;
  const heroImage = node.field_media_item[0];
  const { width } = useWindowDimensions();
  const isMobile = width < SCREEN_TABLET;
  const HERO_MAX_CHARS = 800;

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>
      {isMobile &&
        (
          <div className="NodeLandingPage__hero__image">
            <DynamicMediaItem
              media={heroImage}
            />
          </div>
        )}

      <Container>
        <div className="NodeLandingPage__hero__wrapper">
          <div className="NodeLandingPage__hero__wrapper__text">
            <h1 className="NodeLandingPage__hero__wrapper__title">{heroTitle}</h1>
            {heroBody && (
              <div className="NodeLandingPage__hero-wrapper__body">
                <WysiwygField
                  property="schema:text"
                  html={truncate(heroBody, HERO_MAX_CHARS, '<span>', '</span>', true)}
                />
              </div>
            )}
          </div>

          {!isMobile && (
            <div className="NodeLandingPage__hero__image">
              <DynamicMediaItem
                media={heroImage}
              />
            </div>
          )}
        </div>
      </Container>

      <ParagraphsRenderer className="NodeLandingPage__paragraphs" paragraphs={entity.get('field_paragraphs')} />
    </article>
  );
};

export default NodeLandingPage;
